import { render, staticRenderFns } from "./tablausuarios.vue?vue&type=template&id=ddf3f4a4&scoped=true"
import script from "./tablausuarios.vue?vue&type=script&lang=js"
export * from "./tablausuarios.vue?vue&type=script&lang=js"
import style0 from "./tablausuarios.vue?vue&type=style&index=0&id=ddf3f4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf3f4a4",
  null
  
)

export default component.exports